//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AbasFileClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type SearchAbasFileQueryParameters = {
  search?: string | undefined ;
  onlyMissingOnSharePoint?: boolean | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function searchUrl(search?: string | undefined, onlyMissingOnSharePoint?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/abas-files?";
if (search === null)
    throw new Error("The parameter 'search' cannot be null.");
else if (search !== undefined)
    url_ += "Search=" + encodeURIComponent("" + search) + "&";
if (onlyMissingOnSharePoint === null)
    throw new Error("The parameter 'onlyMissingOnSharePoint' cannot be null.");
else if (onlyMissingOnSharePoint !== undefined)
    url_ += "OnlyMissingOnSharePoint=" + encodeURIComponent("" + onlyMissingOnSharePoint) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let searchDefaultOptions: Omit<UseQueryOptions<Types.AbasFileResponseDto, unknown, Types.AbasFileResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AbasFileResponseDto, unknown, Types.AbasFileResponseDto>, 'queryFn'>> = {
};
export function getSearchDefaultOptions() {
  return searchDefaultOptions;
};
export function setSearchDefaultOptions(options: typeof searchDefaultOptions) {
  searchDefaultOptions = options;
}

export function searchQueryKey(dto: SearchAbasFileQueryParameters): QueryKey;
export function searchQueryKey(search?: string | undefined, onlyMissingOnSharePoint?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function searchQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { search, onlyMissingOnSharePoint, offset, limit, sortBy, sortOrder,  } = params[0] as SearchAbasFileQueryParameters;

    return trimArrayEnd([
        'AbasFileClient',
        'search',
        search as any,
        onlyMissingOnSharePoint as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'AbasFileClient',
        'search',
        ...params
      ]);
  }
}
export function __search(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.search(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as boolean | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined,axiosConfig    );
}

export function useSearchQuery<TSelectData = Types.AbasFileResponseDto, TError = unknown>(dto: SearchAbasFileQueryParameters, options?: Omit<UseQueryOptions<Types.AbasFileResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Searches abas files data.
 * @param search (optional) 
 * @param onlyMissingOnSharePoint (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useSearchQuery<TSelectData = Types.AbasFileResponseDto, TError = unknown>(search?: string | undefined, onlyMissingOnSharePoint?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.AbasFileResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useSearchQuery<TSelectData = Types.AbasFileResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AbasFileResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let search: any = undefined;
  let onlyMissingOnSharePoint: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ search, onlyMissingOnSharePoint, offset, limit, sortBy, sortOrder,  } = params[0] as SearchAbasFileQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [search, onlyMissingOnSharePoint, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AbasFileResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __search(context, axiosConfig) : __search,
    queryKey: searchQueryKey(search, onlyMissingOnSharePoint, offset, limit, sortBy, sortOrder),
    ...searchDefaultOptions as unknown as Omit<UseQueryOptions<Types.AbasFileResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Searches abas files data.
 * @param search (optional) 
 * @param onlyMissingOnSharePoint (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchData(queryClient: QueryClient, updater: (data: Types.AbasFileResponseDto | undefined) => Types.AbasFileResponseDto, search?: string | undefined, onlyMissingOnSharePoint?: boolean | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(searchQueryKey(search, onlyMissingOnSharePoint, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Searches abas files data.
 * @param search (optional) 
 * @param onlyMissingOnSharePoint (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setSearchDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AbasFileResponseDto | undefined) => Types.AbasFileResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}